$(document).ready(function(){
  
  /* ================================================== */
  /* SUMMARY / DETAILS
  /* ================================================== */  

  $('details').on('click', function(){
    if ($(this).attr('open')) {
      $(this).parents('details').removeAttr('open');
    } else {
      $('details').removeAttr('open');
      $(this).attr('open');
    }
  });

	
	/* ================================================== */
  /* SUMMARY / DETAILS FOR NO SUPPORT
  /* ================================================== */  

	$('html').addClass($.fn.details.support ? 'details' : 'no-details');
	
	$('details').details();

});